module.exports = __webpack_public_path__ + "img/gartek-portfolio-central-energy-plants.35895d13.jpeg";